<div style="height: 25vh" id="div_64877722">
  <form
    [formGroup]="feedbackForm"
    (ngSubmit)="submitFeedback()"
    class="p-fluid"
    id="form_p-fluid_f0f72714"
  >
    <div class="p-field" id="div_p-field_f3354a80">
      <label id="label_145f034e">Feedback Type:</label>
      <p-dropdown
        formControlName="feedback_type"
        [options]="feedbackTypes"
        optionLabel="name"
        id="p-dropdown_f58275f0"
      ></p-dropdown>
    </div>
    <div class="p-field" id="div_p-field_4ca3701e">
      <label for="feedback-comments" id="label_c39a0aaf">Comments:</label>
      <textarea
        rows="5"
        [maxLength]="500"
        formControlName="feedback_comment"
        placeholder="Comments"
        id="feedback-comments"
      ></textarea>
    </div>
    <div id="div_ca949bbb">
      <button
        pButton=""
        type="submit"
        style="float: right; width: 25%; margin-top: 3%"
        label="Submit"
        [disabled]="!feedbackForm.valid || feedbackForm.pristine"
        id="button_2311ae1c"
      ></button>
    </div>
  </form>
  <div
    class="progress-spinner"
    *ngIf="loading"
    id="div_progress-spinner_707f3c2f"
  >
    <p-progressSpinner
      styleClass="custom-spinner"
      id="p-progressSpinner_dfe1e5ee"
    ></p-progressSpinner>
  </div>
</div>
